import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, Menu, Store, Users, CheckCircle, BarChart3, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const AdminHeader = ({ title = 'Admin', showBack = false, onBack }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // dropdown state
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-6">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-center gap-3">
              {showBack && (
                <button onClick={() => (onBack ? onBack() : navigate(-1))} className="text-white flex items-center gap-1 px-2 py-1 rounded hover:bg-white/10">
                  <ArrowLeft className="w-4 h-4" />
                  <span className="hidden sm:inline">Back</span>
                </button>
              )}
              <div>
                <h1 className="text-2xl font-bold text-white">{title}</h1>
                <p className="text-blue-100">{currentUser?.email || 'Admin User'}</p>
              </div>
            </div>
          </div>

          {/* Menu */}
          <div className="relative" ref={ref}>
            <button onClick={() => setOpen(!open)} className="flex items-center space-x-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-colors">
              <Menu className="w-4 h-4" />
              <span>Menu</span>
            </button>
            {open && (
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-50">
                {/* <button onClick={() => { setOpen(false); navigate('/admin/dashboard'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2"><BarChart3 className="w-4 h-4" /><span>Dashboard</span></button> */}
                <button onClick={() => { setOpen(false); navigate('/admin/business'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2"><Store className="w-4 h-4" /><span>Business List</span></button>
                <button onClick={() => { setOpen(false); navigate('/admin/users'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2"><Users className="w-4 h-4" /><span>Users</span></button>
                <button onClick={() => { setOpen(false); navigate('/admin/approval'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2"><CheckCircle className="w-4 h-4" /><span>Points Approval</span></button>
                <div className="border-t my-2"></div>
                <button onClick={() => { setOpen(false); navigate('/admin'); }} className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 flex items-center gap-2"><LogOut className="w-4 h-4" /><span>Logout</span></button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
